export default "__VITE_ASSET__DZR0DvuQ__"